export const HeroIconRuble = () => {
  return(
      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="none">
          <circle cx="12.5" cy="12.5" r="12.5" fill="#6482FE"/><path fill="#fff" d="M13.564 9.652H11.78v2.15h1.784a1.076 1.076 0 0 0 0-2.15Z"/>
          <path fill="#fff" d="M18.509 6.49a8.493 8.493 0 0 0-12.018 0 8.493 8.493 0 0 0 0 12.019 8.493 8.493 0 0 0 12.018 0 8.493 8.493 0 0 0 0-12.018Zm-4.945 6.708H11.78v.731h1.43a.698.698 0 1 1 0 1.396h-1.43v.72a.698.698 0 1 1-1.396 0v-.72h-.72a.698.698 0 1 1 0-1.396h.72v-.731h-.72a.698.698 0 1 1 0-1.396h.72V8.954c0-.385.312-.698.698-.698h2.482a2.474 2.474 0 0 1 2.47 2.471 2.474 2.474 0 0 1-2.47 2.471Z"/>
      </svg>
  )
}